<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<div id="advert-filter-create" class="advert-filter-create">

    <mat-card class="mb-3 tab-card">
        <div class="tabs">
            <button type="button" class="tab-btn" [class.active]="activeTab === 'Developed'"
                (click)="activeTab = 'Developed'">Filter for Developed</button>
            <button type="button" class="tab-btn" [class.active]="activeTab === 'Developable'"
                (click)="activeTab = 'Developable'">Filter for Developable</button>
        </div>
    </mat-card>

    <mat-card class="mb-1 optout-card" *ngIf="advertSectorList.length > 0">
        <mat-checkbox [checked]="isActiveSectorOptedOut" [disabled]="isActiveSectorMandatory"
            (change)="onOptOutChange($event.checked)">
            I do not want to publish a property advert under {{ activeTab }}
        </mat-checkbox>
    </mat-card>
    <p class="mandatory-note" *ngIf="isActiveSectorMandatory">
        {{ activeTab }} is required because the property is not being published under {{ otherTab }}.
    </p>

    <mat-card class="mb-3">
        <div class="type-heading" (click)="typeSection.expanded = !typeSection.expanded">
            <h2>Type</h2>
            <button mat-icon-button type="button">
                <mat-icon *ngIf="typeSection.expanded">expand_less</mat-icon>
                <mat-icon *ngIf="!typeSection.expanded">expand_more</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="typeSection.expanded">
            <hr class="type-divider">

            <div class="type-list" *ngIf="activeTab === 'Developable'">
                <div class="simple-type-row" *ngFor="let type of advertTypesList">
                    <span>{{ type.description }}</span>
                    <mat-checkbox [checked]="isTypeSelected(type)"
                        (change)="onTypeToggle(type, $event.checked)"></mat-checkbox>
                </div>
            </div>

            <div class="type-list" *ngIf="activeTab === 'Developed'">
                <div class="type-category" *ngFor="let cat of developedTypeCategories" [class.open]="cat.expanded">
                    <div class="type-category-header" (click)="toggleDevelopedCategory(cat)">
                        <h3>{{ cat.category }}</h3>
                        <span class="toggle-icon">{{ cat.expanded ? '−' : '+' }}</span>
                    </div>
                    <div class="type-category-body" *ngIf="cat.expanded">
                        <div class="subgroup" *ngFor="let sub of cat.subgroups">
                            <p class="subgroup-title" *ngIf="sub.title">{{ sub.title }}</p>
                            <mat-checkbox class="type-item" *ngFor="let item of sub.items"
                                [checked]="isDevelopedItemSelected(item)"
                                (change)="onDevelopedItemToggle(item, $event.checked)">{{ item.name }}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </mat-card>

    <mat-card class="mb-3 field-card">
        <div class="field-heading" (click)="priceSection.expanded = !priceSection.expanded">
            <h2>Asking Price</h2>
            <button mat-icon-button type="button">
                <mat-icon *ngIf="priceSection.expanded">expand_less</mat-icon>
                <mat-icon *ngIf="!priceSection.expanded">expand_more</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="priceSection.expanded">
            <p class="field-note">Seller asking price. Excluding VAT and commission.</p>
            <input type="text" placeholder="R50 000" [(ngModel)]="sellerAskingPriceExcludeVATcommission">
        </ng-container>
    </mat-card>

    <mat-card class="mb-3 field-card">
        <div class="field-heading" (click)="sizeSection.expanded = !sizeSection.expanded">
            <h2>Size: land parcel</h2>
            <button mat-icon-button type="button">
                <mat-icon *ngIf="sizeSection.expanded">expand_less</mat-icon>
                <mat-icon *ngIf="!sizeSection.expanded">expand_more</mat-icon>
            </button>
        </div>
        <ng-container *ngIf="sizeSection.expanded">
            <p class="field-note"><span class="bold">S.G erf extent</span> (sqm for smaller as 1ha; hectares for 1ha
                and bigger)</p>
            <input type="text" placeholder="125 000m&sup2;" [(ngModel)]="SgErfExtent">
        </ng-container>
    </mat-card>

    <div class="col-12 pb-2">
        <div class="button-group mb-3 mt-3">
            <button (click)="saveData()" class="footer-button background-coral" type="button">Save</button>
            <button (click)="saveConfirmDetails()" class="footer-button background-green"
                type="button">Completed</button>
        </div>
    </div>
</div>
